import { matchPath } from 'react-router-dom';

import { tools } from 'tools/tools-list/constants';

export const STAFF_TOOLS_ROOT = '/staff/tools';

// Also names the tool's guide in docs/staff-tools.
export const getStaffToolId = (tool) => tool.toolName || tool.path.slice(STAFF_TOOLS_ROOT.length + 1);

export const getStaffToolsChatContext = (pathname) => {
  const toolsMatch = matchPath(pathname, { path: STAFF_TOOLS_ROOT });

  if (!toolsMatch) {
    return null;
  }

  if (toolsMatch.isExact) {
    return { view: 'tools-list' };
  }

  for (const group of tools) {
    for (const tool of group.items) {
      const formMatch = matchPath(pathname, { path: tool.path, exact: true });
      const runMatch = matchPath(pathname, { path: `${tool.path}/run/:taskYYMM/:taskRunId`, exact: true });

      if (formMatch || runMatch) {
        return {
          view: runMatch ? 'run-detail' : 'tool-form',
          toolId: getStaffToolId(tool),
          toolName: tool.name,
          toolCategory: group.category,
          toolDescription: tool.description,
          route: tool.path,
          ...(tool.requiredCSVHeaders ? { requiredCsvHeaders: tool.requiredCSVHeaders } : {})
        };
      }
    }
  }

  return { view: 'no-tool' };
};
